import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy px-5 py-24 sm:py-32" data-id="element-47" data-mp="piy0if19jjgv">
      <div className="mx-auto flex w-full max-w-[1120px] flex-col items-center" data-id="element-48" data-mp="av39r46tfp6f">
        <div className="mx-auto max-w-[640px] text-center" data-id="element-49" data-mp="at8vg8q1uvbb">
          <Reveal data-id="element-50" data-mp="fsv7wfy207j2">
            <p className="inline-block rounded-full bg-gold px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-navy" data-id="element-51" data-mp="fsbsb5vvlv87">
              Følger med
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-52" data-mp="5xbfi3ip7qz2">
            <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-white sm:text-5xl" data-id="element-53" data-mp="3o1lferpctljg">
              Fem bonusser — helt uden ekstra betaling
            </h2>
          </Reveal>

          <Reveal delay={0.12} data-id="element-54" data-mp="1m9qiji7rblla">
            <p className="mx-auto mt-6 max-w-[560px] text-base leading-relaxed text-white/70" data-id="element-55" data-mp="1mbjpkyma87tt">
              Bonusserne handler om alt det, der foregår uden for banen. Det er der, de
              fleste frivillige trænere bruger deres tid.
            </p>
          </Reveal>
        </div>

        <ul className="mt-14 grid w-full max-w-[900px] gap-6 sm:grid-cols-2" data-id="element-56" data-mp="3deaepkcm6eh6">
          {bonuses.map((bonus, index) => {
          const isLast = index === bonuses.length - 1;
          return <Reveal as="li" key={bonus.title} delay={index % 2 * 0.06} className={isLast ? 'sm:col-span-2 sm:mx-auto sm:w-full sm:max-w-[calc(50%-12px)]' : ''} data-id="element-57" data-mp="3n6g2sizqwbr3" data-mpi={index}>
                <article className="flex h-full flex-col items-center rounded-card border border-white/[0.12] bg-white/[0.05] px-7 py-8 text-center" data-id="element-58" data-mp="38gikuksesiac">
                  <span className="rounded-full border border-gold/50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold" data-id="element-59" data-mp="33ja32lb6ag9m">
                    {bonus.value}
                  </span>

                  <h3 className="mt-5 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white" data-id="element-60" data-mp="it14cm19dw09">
                    {bonus.title}
                  </h3>

                  <p className="mt-auto pt-3 text-base leading-relaxed text-white/70" data-id="element-61" data-mp="3hgg7rw96q8e9">
                    {bonus.body}
                  </p>
                </article>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.12} data-id="element-62" data-mp="3qgbk44eh89fv">
          <p className="mt-14 text-center font-display text-2xl font-bold uppercase tracking-[0.12em] text-gold sm:text-3xl" data-id="element-63" data-mp="2tsyiq8hb1oez">
            Samlet værdi af bonusserne: 445 kr.
          </p>
        </Reveal>
      </div>
    </section>;
}